<template>
<div class="chapter">
<div class="inner_page">
<h1>The Highest Mountain</h1>
<h1 class="sigil_not_in_toc">And seven more Stories Vol II</h1>
<h2 class="sigil_not_in_toc">Bryce Walton</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?063af867